import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import ChartComponent from "../FixedReportChart";

class DailyMeetingByProject extends React.Component {
  constructor(props) {
    super(props);

    // Load project options from local storage
    const ProjectOptions = reactLocalStorage.getObject(Constants.Model).project.options;

    this.state = {
      projectData: [], // Data received from the API
      ProjectOptions,  // Predefined project options
    };
  }

  componentDidMount() {
    // Fetch data from the API
    DailySalesReportAPI.getMeetingByProject(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    // Filter out items where project is 0
    const filteredData = data.filter(item => item.project !== 0);
    this.setState({ projectData: filteredData });
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const { projectData, ProjectOptions } = this.state;

    // Create a record of sums for each project option, starting at 0
    const projectSums = {};
    ProjectOptions.forEach(option => {
      projectSums[option.value] = 0;
    });

    // Fill in the actual values from the API data
    projectData.forEach(item => {
      if (projectSums.hasOwnProperty(item.project)) {
        projectSums[item.project] += item.sum;
      }
    });

    // Calculate the total sum of all project values
    const totalSum = Object.values(projectSums).filter(Boolean).reduce((total, value) => total + value, 0);

    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Site Visit By project Report</h2>
          <hr />
          <div className="row mt-3">
          <Table striped bordered hover className="col-md-5">
            <thead>
              <tr>
                <th>Site Visit</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {ProjectOptions.map((option, index) => (
                <tr key={index}>
                  <td>{option.label}</td>
                  <td>{projectSums[option.value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-5">
            {/* Add Chart Component */}
            <ChartComponent progressSums={projectSums} progressOptions={ProjectOptions} type="bar" />
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(DailyMeetingByProject);
